<template>
  <div :style="'margin-left:' + level * 35 + 'px;'">
    <v-autocomplete
      :label="$t('settings.workflow.acceptors')"
      v-model="contextUserIds"
      :items="users"
      style="width: 300px; display: flex"
      item-value="id"
      item-text="fullName"
      multiple
      small-chips
      deletable-chips
    />
  </div>
</template>

<script>
export default {
  name: "WorkflowItemAcceptationBy",
  props: {
    userIds: {
      //type: Object,
      required: true
    },
    level: {
      default: 0,
      required: false
    }
  },
  data: () => ({}),
  methods: {
    downloadUsers() {
      this.axios.get("").then();
    }
  },
  computed: {
    contextUserIds: {
      get() {
        return this.userIds;
      },
      set(val) {
        this.$emit("update:userIds", val);
      }
    },
    users() {
      return this.$store.state.Settings.workflowData.users;
    }
  }
};
</script>

<style scoped />
